package com.videoanalyzer.web.screens

import androidx.compose.runtime.Composable
import com.videoanalyzer.web.components.*
import com.videoanalyzer.web.state.AnalysisState
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

/**
 * Home screen with video analysis form and results.
 */
@Composable
fun HomeScreen(
    analysisState: AnalysisState,
    onAnalyze: (String) -> Unit,
    onNewAnalysis: () -> Unit,
    onUpgrade: () -> Unit,
    onBuyCredits: (String) -> Unit,
    isCheckoutLoading: Boolean
) {
    Div({
        style {
            maxWidth(1200.px)
            margin(0.px, "auto".unsafeCast<CSSNumeric>())
        }
    }) {
        when (analysisState) {
            is AnalysisState.Idle -> {
                AnalyzerForm(
                    isLoading = false,
                    error = null,
                    onAnalyze = onAnalyze
                )
                EmptyAnalysisState()
            }

            is AnalysisState.LoadingVideo,
            is AnalysisState.Analyzing -> {
                AnalyzerForm(
                    isLoading = true,
                    error = null,
                    onAnalyze = onAnalyze
                )
                Div({
                    style {
                        marginTop(48.px)
                    }
                }) {
                    LoadingSpinner("Analyzing your video with AI...")
                }
            }

            is AnalysisState.VideoLoaded -> {
                AnalyzerForm(
                    isLoading = false,
                    error = null,
                    onAnalyze = onAnalyze
                )
            }

            is AnalysisState.Success -> {
                ResultsCard(
                    analysis = analysisState.analysis,
                    isExisting = analysisState.isExisting,
                    message = analysisState.message,
                    onNewAnalysis = onNewAnalysis,
                    showFullRecommendations = analysisState.showFullRecommendations,
                    totalRecommendationsCount = analysisState.totalRecommendationsCount,
                    freeRecommendationsLimit = analysisState.freeRecommendationsLimit,
                    onUpgrade = onUpgrade
                )
            }

            is AnalysisState.Error -> {
                AnalyzerForm(
                    isLoading = false,
                    error = analysisState.message,
                    onAnalyze = onAnalyze
                )
            }

            is AnalysisState.LimitReached -> {
                LimitReachedScreen(
                    currentUsage = analysisState.currentUsage,
                    limit = analysisState.limit,
                    isLoading = isCheckoutLoading,
                    onUpgrade = onUpgrade,
                    onBuyCredits = onBuyCredits,
                    onBack = onNewAnalysis
                )
            }
        }
    }
}
